import React, { useContext } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from 'pages/admin/home'
import Login from 'pages/login'
import Balance from 'pages/admin/balance'
import Agent from 'pages/admin/agent'
import Client from 'pages/client/home'
import ProtectedRoute from 'helpers/routeProtected'
import { UserContext } from 'contexts/UserContext'
import Layout from 'layout/layout'

const PagesRoutes = () => {
  const { user } = useContext(UserContext)
  const location = useLocation()
  return (
    <Layout show={location.pathname === '/login'}>
      <Routes>
        <Route exact path="/login" element={<Login />} />

        <Route element={<ProtectedRoute isAuthenticated={user?.success} />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/balance" element={<Balance />} />
          <Route exact path="/agent" element={<Agent />} />

          <Route exact path="/Client" element={<Client />} />
          {/* <Route exact path="/updateClient/:id" element={<UpdateClient />} /> */}
        </Route>

        <Route exact path="*" element={<div>404 not found</div>} />
      </Routes>
    </Layout>
  )
}
export default PagesRoutes
